import api from 'api';

const loadAffiliates = api('GET /api/applications/fields/affiliates');

export const loadReIds = async () => {
  const [affiliates] = await Promise.all([loadAffiliates()]);

  return {
    affiliates,
  };
};
